// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-area[data-v-7f0ba188]{position:relative}.loading-spinner[data-v-7f0ba188],.pause-button[data-v-7f0ba188],.play-button[data-v-7f0ba188]{position:absolute;top:0;bottom:0;margin:auto;width:100%}.pause-button[data-v-7f0ba188],.play-button[data-v-7f0ba188]{height:52px}.pause-button[data-v-7f0ba188]{display:none}.video-area:hover .pause-button[data-v-7f0ba188]{display:block}", ""]);
// Exports
module.exports = exports;
